import { Theme } from '@user-portal/wikr-components';
import { createGlobalStyle } from 'styled-components';

import { color } from './selectors';
import resetStyles from './styles/reset';

const GlobalStyle = createGlobalStyle<{ rootVariables: string; theme: Theme }>`
    ${resetStyles}

    :root {
        ${({ rootVariables }) => rootVariables}
    }

    body,
    html{
        height: 100%;
        font-family: 'Roboto', sans-serif;
        }

        textarea {
        font-family: var(--font-family) !important;
        }

    body {
        background: ${color('secondary-default')};

        &.ReactModal__Body--open {
            overflow: hidden;
        }
    }

`;

export default GlobalStyle;
